import { motion } from "framer-motion";
import angelaImg from "@/assets/angela-standing.jpg";
import wtaLogo from "@/assets/wta-logo.png";
import EmailSignup from "./EmailSignup";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden isolate">
      {/* Subtle gold radial glow */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_top_right,_hsl(43_72%_55%_/_0.06),_transparent_60%)]" />
      
      <div className="container relative z-10 mx-auto px-5 sm:px-6 md:px-12 py-20 md:py-0">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left: Copy */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="relative z-30 space-y-8 order-2 md:order-1"
          >
            <div className="space-y-4">
              <motion.img
                src={wtaLogo}
                alt="Wealth Transfer Academy Logo"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2, duration: 0.8 }}
                className="w-28 h-28 md:w-36 md:h-36 object-contain drop-shadow-[0_0_25px_hsl(43_72%_55%_/_0.3)]"
              />
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-xs uppercase tracking-[0.4em] text-gold font-body font-medium"
              >
                Enrollment Is Now Open
              </motion.p>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-[1.1] text-foreground">
                Shift Your Mind,
                <br />
                <span className="text-gradient-gold">Step Into</span>
                <br />
                Wealth
              </h1>
            </div>

            <p className="text-muted-foreground font-body text-base md:text-lg leading-relaxed max-w-md">
              Financial success and prosperity are within reach. The Wealth Transfer Academy empowers you with the knowledge, strategies, and mindset to build lasting wealth and secure a prosperous future.
            </p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="relative inline-flex items-center gap-4 px-6 py-4 border border-gold/40 bg-secondary/60 backdrop-blur-sm shadow-gold"
            >
              {/* Corner flourishes */}
              <div className="absolute -top-1 -left-1 w-3 h-3 border-t border-l border-gold" />
              <div className="absolute -top-1 -right-1 w-3 h-3 border-t border-r border-gold" />
              <div className="absolute -bottom-1 -left-1 w-3 h-3 border-b border-l border-gold" />
              <div className="absolute -bottom-1 -right-1 w-3 h-3 border-b border-r border-gold" />

              {/* Live pulse indicator */}
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-60" />
                <span className="relative inline-flex rounded-full h-3 w-3 bg-gold" />
              </span>

              <span className="text-lg sm:text-xl md:text-2xl font-display font-bold uppercase tracking-widest text-gradient-gold">
                ENROLLING NOW!
              </span>
            </motion.div>

            <EmailSignup />
          </motion.div>

          {/* Right: Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, delay: 0.2, ease: "easeOut" }}
            className="relative z-10 order-1 md:order-2 flex justify-center pointer-events-none"
          >
            <div className="relative pointer-events-none select-none">
              {/* Gold border accent */}
              <div className="absolute -inset-3 border border-gold/20 pointer-events-none" />
              <div className="absolute -inset-6 border border-gold/10 pointer-events-none" />
                <img
                src={angelaImg}
                alt="Angela Joseph Roberson, Founder of Wealth Transfer Academy"
                className="relative w-full max-w-xs sm:max-w-sm md:max-w-md object-cover shadow-luxury max-h-[60vh] md:max-h-none"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
